/**
 * Safe file name for downloads (no path segments or illegal characters).
 */
export function sanitizeDownloadFileName(name) {
  if (name == null || name === "") return "download";
  let s = String(name).trim();
  s = s.split(/[/\\]/).pop() || "download";
  s = s.replace(/[<>:"/\\|?*]/g, "_").replace(/\s+/g, "_").trim();
  return s || "download";
}

/**
 * Programmatic download with a stable suggested filename.
 * Appends the anchor to document.body so Chromium / Playwright respect `download`.
 */
export function downloadDataUri(dataUri, fileName) {
  const safe = sanitizeDownloadFileName(fileName);
  const a = document.createElement("a");
  a.href = dataUri;
  a.setAttribute("download", safe);
  a.rel = "noopener";
  a.style.position = "fixed";
  a.style.left = "-9999px";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  if (typeof dataUri === "string" && dataUri.startsWith("blob:")) {
    URL.revokeObjectURL(dataUri);
  }
}

/**
 * Legacy ".xls" export (HTML workbook) from a <table id="...">.
 * Uses a Blob + object URL so `download` / Playwright suggestedFilename work reliably.
 */
export function downloadTableAsExcel(tableId, sheetName, fileNameBase) {
  const el = document.getElementById(tableId);
  if (!el || el.nodeName !== "TABLE") {
    console.error("downloadTableAsExcel: expected TABLE#", tableId);
    return false;
  }
  const table = el.outerHTML;
  const worksheet = String(sheetName || "Worksheet").replace(/[<>&]/g, "_");
  const html =
    '<html xmlns:o="urn:schemas-microsoft-com:office:office" ' +
    'xmlns:x="urn:schemas-microsoft-com:office:excel" ' +
    'xmlns="http://www.w3.org/TR/REC-html40">' +
    '<head><meta charset="UTF-8">' +
    "<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>" +
    "<x:Name>" +
    worksheet +
    "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->" +
    "</head><body>" +
    table +
    "</body></html>";

  const blob = new Blob([html], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const name = sanitizeDownloadFileName(fileNameBase) + ".xls";
  downloadDataUri(url, name);
  return true;
}
